{
  "header": {
    "title": "Manage Generators",
    "description": "Review generator registrations and manage linked generation units."
  },
  "filters": {
    "company": [
      "All",
      "SolarOne Plant 1",
      "WindStar Plant 2",
      "SunPower Plant 3",
      "SolarOne Plant 4",
      "WindStar Plant 5",
      "SolarOne Plant 6",
      "GreenWind Plant 7",
      "SunPower Plant 8",
      "EcoHybrid Plant 9",
      "SolarOne Plant 10"
    ],
    "qca": [
      "All",
      "MH_MANIKARAN (QCA-001)",
      "MH_RECONNECT (QCA-002)",
      "MH_STATKRAFT (QCA-003)",
      "MH_VEDANJAY (QCA-004)",
      "MH_KREATE (QCA-005)",
      "MH_TPREL (QCA-006)",
      "MH_CLEAN (QCA-007)",
      "MH_WALWHAN (QCA-008)",
      "MH_MSEDCL (QCA-009)",
      "MH_SHARDA (QCA-010)"
    ],
    "pss": [
      "All",
      "Ahmednagar PSS 1",
      "Solapur PSS 2",
      "Jalgaon PSS 3",
      "Kolhapur PSS 4",
      "Jalgaon PSS 5",
      "Solapur PSS 6",
      "Nashik PSS 7",
      "Amravati PSS 8",
      "Kolhapur PSS 9",
      "Amravati PSS 10"
    ],
    "technology": [
      "All",
      "Solar",
      "Wind",
      "Hybrid"
    ],
    "status": [
      "All",
      "Operational"
    ]
  },
  "rows": [
    {
      "code": "GNR-001",
      "name": "SolarOne Plant 1",
      "companyCode": "GEN-001",
      "companyName": "SolarOne Plant 1",
      "qcaCode": "QCA-001",
      "qcaName": "MH_MANIKARAN",
      "pssCode": "PSS-001",
      "pssName": "Ahmednagar PSS 1",
      "technology": "Solar",
      "organizationType": "Private Ltd.",
      "sourceType": "Solar",
      "fuelType": "Solar Irradiance",
      "parentCompany": "SolarOne Plant 1",
      "scadaStationCode": "SCADA-AUR-01",
      "connectingSubstation": "Ahmednagar PSS 1",
      "connectingVoltageLevelKv": "132",
      "voltageLevelKv": "132",
      "installedCapacityMw": 20,
      "generatorCapacityMw": 20,
      "commissionDate": "03-Jan-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-002",
      "name": "WindStar Plant 2",
      "companyCode": "GEN-002",
      "companyName": "WindStar Plant 2",
      "qcaCode": "QCA-002",
      "qcaName": "MH_RECONNECT",
      "pssCode": "PSS-002",
      "pssName": "Solapur PSS 2",
      "technology": "Solar",
      "organizationType": "LLP",
      "sourceType": "Solar",
      "fuelType": "Solar Irradiance",
      "parentCompany": "WindStar Plant 2",
      "scadaStationCode": "SCADA-KOL-02",
      "connectingSubstation": "Solapur PSS 2",
      "connectingVoltageLevelKv": "220",
      "voltageLevelKv": "220",
      "installedCapacityMw": 30,
      "generatorCapacityMw": 30,
      "commissionDate": "06-Feb-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-003",
      "name": "SunPower Plant 3",
      "companyCode": "GEN-003",
      "companyName": "SunPower Plant 3",
      "qcaCode": "QCA-003",
      "qcaName": "MH_STATKRAFT",
      "pssCode": "PSS-003",
      "pssName": "Jalgaon PSS 3",
      "technology": "Solar",
      "organizationType": "Public Ltd.",
      "sourceType": "Solar",
      "fuelType": "Solar Irradiance",
      "parentCompany": "SunPower Plant 3",
      "scadaStationCode": "SCADA-NAS-03",
      "connectingSubstation": "Jalgaon PSS 3",
      "connectingVoltageLevelKv": "132",
      "voltageLevelKv": "132",
      "installedCapacityMw": 120,
      "generatorCapacityMw": 120,
      "commissionDate": "09-Mar-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-004",
      "name": "SolarOne Plant 4",
      "companyCode": "GEN-004",
      "companyName": "SolarOne Plant 4",
      "qcaCode": "QCA-004",
      "qcaName": "MH_VEDANJAY",
      "pssCode": "PSS-004",
      "pssName": "Kolhapur PSS 4",
      "technology": "Wind",
      "organizationType": "Private Ltd.",
      "sourceType": "Wind",
      "fuelType": "Wind Resource",
      "parentCompany": "SolarOne Plant 4",
      "scadaStationCode": "SCADA-MUM-04",
      "connectingSubstation": "Kolhapur PSS 4",
      "connectingVoltageLevelKv": "132",
      "voltageLevelKv": "132",
      "installedCapacityMw": 100,
      "generatorCapacityMw": 100,
      "commissionDate": "12-Apr-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-005",
      "name": "WindStar Plant 5",
      "companyCode": "GEN-005",
      "companyName": "WindStar Plant 5",
      "qcaCode": "QCA-005",
      "qcaName": "MH_KREATE",
      "pssCode": "PSS-005",
      "pssName": "Jalgaon PSS 5",
      "technology": "Wind",
      "organizationType": "LLP",
      "sourceType": "Wind",
      "fuelType": "Wind Resource",
      "parentCompany": "WindStar Plant 5",
      "scadaStationCode": "SCADA-AMR-05",
      "connectingSubstation": "Jalgaon PSS 5",
      "connectingVoltageLevelKv": "132",
      "voltageLevelKv": "132",
      "installedCapacityMw": 75,
      "generatorCapacityMw": 75,
      "commissionDate": "15-May-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-006",
      "name": "SolarOne Plant 6",
      "companyCode": "GEN-006",
      "companyName": "SolarOne Plant 6",
      "qcaCode": "QCA-006",
      "qcaName": "MH_TPREL",
      "pssCode": "PSS-006",
      "pssName": "Solapur PSS 6",
      "technology": "Wind",
      "organizationType": "Public Ltd.",
      "sourceType": "Wind",
      "fuelType": "Wind Resource",
      "parentCompany": "SolarOne Plant 6",
      "scadaStationCode": "SCADA-AHM-06",
      "connectingSubstation": "Solapur PSS 6",
      "connectingVoltageLevelKv": "400",
      "voltageLevelKv": "400",
      "installedCapacityMw": 25,
      "generatorCapacityMw": 25,
      "commissionDate": "18-Jun-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-007",
      "name": "GreenWind Plant 7",
      "companyCode": "GEN-007",
      "companyName": "GreenWind Plant 7",
      "qcaCode": "QCA-007",
      "qcaName": "MH_CLEAN",
      "pssCode": "PSS-007",
      "pssName": "Nashik PSS 7",
      "technology": "Solar",
      "organizationType": "Private Ltd.",
      "sourceType": "Solar",
      "fuelType": "Solar Irradiance",
      "parentCompany": "GreenWind Plant 7",
      "scadaStationCode": "SCADA-SOL-07",
      "connectingSubstation": "Nashik PSS 7",
      "connectingVoltageLevelKv": "400",
      "voltageLevelKv": "400",
      "installedCapacityMw": 20,
      "generatorCapacityMw": 20,
      "commissionDate": "21-Jul-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-008",
      "name": "SunPower Plant 8",
      "companyCode": "GEN-008",
      "companyName": "SunPower Plant 8",
      "qcaCode": "QCA-008",
      "qcaName": "MH_WALWHAN",
      "pssCode": "PSS-008",
      "pssName": "Amravati PSS 8",
      "technology": "Wind",
      "organizationType": "LLP",
      "sourceType": "Wind",
      "fuelType": "Wind Resource",
      "parentCompany": "SunPower Plant 8",
      "scadaStationCode": "SCADA-JAL-08",
      "connectingSubstation": "Amravati PSS 8",
      "connectingVoltageLevelKv": "220",
      "voltageLevelKv": "220",
      "installedCapacityMw": 40,
      "generatorCapacityMw": 40,
      "commissionDate": "24-Aug-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-009",
      "name": "EcoHybrid Plant 9",
      "companyCode": "GEN-009",
      "companyName": "EcoHybrid Plant 9",
      "qcaCode": "QCA-009",
      "qcaName": "MH_MSEDCL",
      "pssCode": "PSS-009",
      "pssName": "Kolhapur PSS 9",
      "technology": "Hybrid",
      "organizationType": "Public Ltd.",
      "sourceType": "Hybrid",
      "fuelType": "Solar + Wind",
      "parentCompany": "EcoHybrid Plant 9",
      "scadaStationCode": "SCADA-LAT-09",
      "connectingSubstation": "Kolhapur PSS 9",
      "connectingVoltageLevelKv": "400",
      "voltageLevelKv": "400",
      "installedCapacityMw": 20,
      "generatorCapacityMw": 20,
      "commissionDate": "27-Sep-2024",
      "status": "Operational",
      "remarks": "-"
    },
    {
      "code": "GNR-010",
      "name": "SolarOne Plant 10",
      "companyCode": "GEN-010",
      "companyName": "SolarOne Plant 10",
      "qcaCode": "QCA-010",
      "qcaName": "MH_SHARDA",
      "pssCode": "PSS-010",
      "pssName": "Amravati PSS 10",
      "technology": "Wind",
      "organizationType": "Private Ltd.",
      "sourceType": "Wind",
      "fuelType": "Wind Resource",
      "parentCompany": "SolarOne Plant 10",
      "scadaStationCode": "SCADA-LAT-10",
      "connectingSubstation": "Amravati PSS 10",
      "connectingVoltageLevelKv": "132",
      "voltageLevelKv": "132",
      "installedCapacityMw": 100,
      "generatorCapacityMw": 100,
      "commissionDate": "02-Oct-2024",
      "status": "Operational",
      "remarks": "-"
    }
  ],
  "unitCatalog": [
    {
      "code": "UNIT-1001",
      "uniqueNo": "UNIT-1001",
      "model": "SP-Unit-01",
      "generator": "SolarOne Plant 1",
      "purchaseMode": "Captive",
      "installedCapacityMw": 50.0,
      "status": "Operational",
      "developerName": "SunPower Renewables Pvt Ltd",
      "commissionDate": "03-Jan-2024"
    },
    {
      "code": "UNIT-1002",
      "uniqueNo": "UNIT-1002",
      "model": "SP-Unit-02",
      "generator": "SolarOne Plant 1",
      "purchaseMode": "Captive",
      "installedCapacityMw": 50.0,
      "status": "Operational",
      "developerName": "SunPower Renewables Pvt Ltd",
      "commissionDate": "03-Jan-2024"
    },
    {
      "code": "UNIT-1003",
      "uniqueNo": "UNIT-1003",
      "model": "SP-Unit-03",
      "generator": "SolarOne Plant 1",
      "purchaseMode": "Merchant",
      "installedCapacityMw": 20.0,
      "status": "Operational",
      "developerName": "SunPower Renewables Pvt Ltd",
      "commissionDate": "03-Jan-2024"
    },
    {
      "code": "UNIT-2001",
      "uniqueNo": "UNIT-2001",
      "model": "MW-Unit-01",
      "generator": "SunPower Plant 3",
      "purchaseMode": "Third Party PPA",
      "installedCapacityMw": 90.0,
      "status": "Operational",
      "developerName": "Maharashtra Wind Farm",
      "commissionDate": "09-Mar-2024"
    },
    {
      "code": "UNIT-2002",
      "uniqueNo": "UNIT-2002",
      "model": "MW-Unit-02",
      "generator": "SunPower Plant 3",
      "purchaseMode": "Third Party PPA",
      "installedCapacityMw": 90.0,
      "status": "Operational",
      "developerName": "Maharashtra Wind Farm",
      "commissionDate": "09-Mar-2024"
    },
    {
      "code": "UNIT-3001",
      "uniqueNo": "UNIT-3001",
      "model": "GH-Unit-01",
      "generator": "SolarOne Plant 4",
      "purchaseMode": "Captive",
      "installedCapacityMw": 70.0,
      "status": "Operational",
      "developerName": "Green Hybrid Plant",
      "commissionDate": "12-Apr-2024"
    },
    {
      "code": "UNIT-3002",
      "uniqueNo": "UNIT-3002",
      "model": "GH-Unit-02",
      "generator": "SolarOne Plant 4",
      "purchaseMode": "Captive",
      "installedCapacityMw": 70.0,
      "status": "Operational",
      "developerName": "Green Hybrid Plant",
      "commissionDate": "12-Apr-2024"
    },
    {
      "code": "UNIT-4001",
      "uniqueNo": "UNIT-4001",
      "model": "WS-Unit-01",
      "generator": "WindStar Plant 5",
      "purchaseMode": "Utility",
      "installedCapacityMw": 80.0,
      "status": "Operational",
      "developerName": "WindStar Farm",
      "commissionDate": "15-May-2024"
    },
    {
      "code": "UNIT-5001",
      "uniqueNo": "UNIT-5001",
      "model": "VS-Unit-01",
      "generator": "SolarOne Plant 6",
      "purchaseMode": "Captive",
      "installedCapacityMw": 55.0,
      "status": "Operational",
      "developerName": "Vidarbha Solar Assets",
      "commissionDate": "18-Jun-2024"
    },
    {
      "code": "UNIT-5002",
      "uniqueNo": "UNIT-5002",
      "model": "VS-Unit-02",
      "generator": "SolarOne Plant 6",
      "purchaseMode": "Captive",
      "installedCapacityMw": 55.0,
      "status": "Operational",
      "developerName": "Vidarbha Solar Assets",
      "commissionDate": "18-Jun-2024"
    },
    {
      "code": "UNIT-6001",
      "uniqueNo": "UNIT-6001",
      "model": "CW-Unit-01",
      "generator": "GreenWind Plant 7",
      "purchaseMode": "Utility",
      "installedCapacityMw": 52.5,
      "status": "Operational",
      "developerName": "Coastal Wind Assets",
      "commissionDate": "21-Jul-2024"
    },
    {
      "code": "UNIT-6002",
      "uniqueNo": "UNIT-6002",
      "model": "CW-Unit-02",
      "generator": "GreenWind Plant 7",
      "purchaseMode": "Utility",
      "installedCapacityMw": 52.5,
      "status": "Operational",
      "developerName": "Coastal Wind Assets",
      "commissionDate": "21-Jul-2024"
    },
    {
      "code": "UNIT-7001",
      "uniqueNo": "UNIT-7001",
      "model": "RH-Unit-01",
      "generator": "SunPower Plant 8",
      "purchaseMode": "Third Party PPA",
      "installedCapacityMw": 65.0,
      "status": "Operational",
      "developerName": "Riverfront Hybrid Energy",
      "commissionDate": "24-Aug-2024"
    },
    {
      "code": "UNIT-7002",
      "uniqueNo": "UNIT-7002",
      "model": "RH-Unit-02",
      "generator": "SunPower Plant 8",
      "purchaseMode": "Third Party PPA",
      "installedCapacityMw": 65.0,
      "status": "Operational",
      "developerName": "Riverfront Hybrid Energy",
      "commissionDate": "24-Aug-2024"
    },
    {
      "code": "UNIT-8001",
      "uniqueNo": "UNIT-8001",
      "model": "PS-Unit-01",
      "generator": "EcoHybrid Plant 9",
      "purchaseMode": "Captive",
      "installedCapacityMw": 80.0,
      "status": "Operational",
      "developerName": "Peak Solar Assets",
      "commissionDate": "27-Sep-2024"
    },
    {
      "code": "UNIT-8002",
      "uniqueNo": "UNIT-8002",
      "model": "PS-Unit-02",
      "generator": "EcoHybrid Plant 9",
      "purchaseMode": "Captive",
      "installedCapacityMw": 80.0,
      "status": "Operational",
      "developerName": "Peak Solar Assets",
      "commissionDate": "27-Sep-2024"
    },
    {
      "code": "UNIT-9001",
      "uniqueNo": "UNIT-9001",
      "model": "SW-Unit-01",
      "generator": "SolarOne Plant 10",
      "purchaseMode": "Utility",
      "installedCapacityMw": 49.0,
      "status": "Operational",
      "developerName": "Sunrise Wind Ventures",
      "commissionDate": "02-Oct-2024"
    },
    {
      "code": "UNIT-9002",
      "uniqueNo": "UNIT-9002",
      "model": "SW-Unit-02",
      "generator": "SolarOne Plant 10",
      "purchaseMode": "Utility",
      "installedCapacityMw": 49.0,
      "status": "Operational",
      "developerName": "Sunrise Wind Ventures",
      "commissionDate": "02-Oct-2024"
    }
  ],
  "generatorUnitMappings": {
    "GNR-001": [
      "UNIT-1001",
      "UNIT-1002",
      "UNIT-1003"
    ],
    "GNR-003": [
      "UNIT-2001",
      "UNIT-2002"
    ],
    "GNR-004": [
      "UNIT-3001",
      "UNIT-3002"
    ],
    "GNR-005": [
      "UNIT-4001"
    ],
    "GNR-006": [
      "UNIT-5001",
      "UNIT-5002"
    ],
    "GNR-007": [
      "UNIT-6001",
      "UNIT-6002"
    ],
    "GNR-008": [
      "UNIT-7001",
      "UNIT-7002"
    ],
    "GNR-009": [
      "UNIT-8001",
      "UNIT-8002"
    ],
    "GNR-010": [
      "UNIT-9001",
      "UNIT-9002"
    ]
  }
}
